import * as type from 'store/scheduler/schedulerTypes'

export function fetchModeratorAvailability(payload){
    return{
        type: type.FETCH_MODERATOR_AVAILABILITY_REQUESTED,
        payload: payload
    }
}

export function postModeratorAvailability(payload){
    return{
        type: type.POST_MODERATOR_AVAILABILITY_REQUESTED,
        payload: payload
    }
}

export function putModeratorAvailability(payload){
    return{
        type: type.PUT_MODERATOR_AVAILABILITY_REQUESTED,
        payload: payload
    }
}


export function fetchAvailabilityAndTimeslotsForProject(payload){
    return{
        type: type.FETCH_AVAILABILITY_AND_TIMESLOTS_FOR_PROJECT_REQUESTED,
        payload: payload
    }
}

export function fetchImportAvailabilityStatus(payload){
    return{
        type: type.FETCH_IMPORT_AVAILABILITY_STATUS_REQUESTED,
        payload: payload
    }
}

export function startFetchImporetdModeratorAvailability(payload){
    return{
        type: type.START_FETCH_IMPORTED_MOD_AV_REQUESTED,
        payload: payload
    }
}

export function unlinkModeratorCalendar(payload){
    return{
        type: type.UNLINK_MODERATOR_CALENDAR,
        payload: payload
    }
}

export function updateGoogleSpreadSheet(){
    return{
        type: type.UPDATE_GOOGLE_SPREAD_SHEET,
    }
}

